// ----------------------------------------------------------------------

const account = {
  displayName: 'Super Admin',
  email: '',
  photoURL: '/favicon/logo.png',
};

export default account;
